import React, { FC } from 'react';
import { LegacyUser } from 'src/interfaces/api/User';
import { LegacyEmployee } from 'src/interfaces/api/Employee';
import Card from 'src/components/Card';
import { FiMail as EmailIcon } from '@react-icons/all-files/fi/FiMail';
import { FiPhone as PhoneIcon } from '@react-icons/all-files/fi/FiPhone';
import { Box, Divider, Grid, Typography } from '@material-ui/core';
import AboutRow from './components/AboutRow';

interface Props {
  user: LegacyUser & {
    typeUser: Omit<LegacyEmployee, 'user'>;
  };
}

const AboutCard: FC<Props> = ({ user }) => {
  return (
    <Card>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant='h6'>À propos</Typography>

          <Box marginTop='19px !important' marginBottom='12px !important'>
            {(props) => <Divider component='div' {...props} />}
          </Box>
        </Grid>

        <Grid item xs={12}>
          <AboutRow icon={EmailIcon} text={user.email} />
        </Grid>

        {user.typeUser?.phoneNumber && (
          <Grid item xs={12}>
            <AboutRow icon={PhoneIcon} text={user.typeUser.phoneNumber} />
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default AboutCard;
